module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createIntercom
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    attrs: {
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.intercom.name),
      callback: function($$v) {
        _vm.$set(_vm.intercom, "name", $$v)
      },
      expression: "intercom.name"
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15750f27","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/Intercom/CreateIntercom.vue
// module id = 605
// module chunks = 1